import { __decorate, __metadata, __param } from "tslib";
import { format } from '@/@core/utils/string';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
let DataResourceApi = class DataResourceApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    getCurrentUserDataResource() {
        const url = this.urls.getCurrentUserDataResource;
        return this.http.get({
            url,
            isAuthorizationCache: true,
        });
    }
    getProductDataResources(product_id) {
        const url = format(this.urls.getProductDataResources, {
            product_id,
        });
        return this.http.get({
            url,
        });
    }
    getRoleDataResources(role_id) {
        const url = format(this.urls.getRoleDataResources, {
            role_id,
        });
        return this.http.get({
            url,
        });
    }
};
DataResourceApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.DataResourceApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], DataResourceApi);
export { DataResourceApi };
